<template>
  <div class="signup-verify">
    <p class="title">
      メールをご確認ください
    </p>

    <p class="email-address">
      {{emailAddressToCheck}}
    </p>

    <p class="instructions">
      上記メールアドレスに、本登録用のURLを送信しました。<br>
      メールに記載のURLより本登録を行ってください。(メールの有効期限は24時間)<br>
      完了しないまま24時間を過ぎてしまった場合は、もう1度はじめからお手続きが必要で<span @click="$emit('verify')">す</span>。
    </p>

    <div class="tips">
      <h4>認証メールが届かない場合は、下記をご確認ください</h4>

      <ul>
        <li>
          <p>(1) <span>ドメイン指定拒否をしていませんか？</span></p>
          <p>設定をご確認の上、@lancul.comからのメールを受信許可に設定してください。</p>
        </li>

        <li>
          <p>(2) <span>迷惑メールに振り分けられていませんか？</span></p>
          <p>自動で迷惑メールに振り分けられている可能性があります。今一度お手元の受信メールをご確認ください。</p>
        </li>

        <li>
          <p>(3) <span>ご登録いただいたメールアドレスの入力は正しいですか？</span></p>
          <p>ご入力いただいたメールアドレスが間違っていた可能性があります。再度正しいメールアドレスにてご登録ください。</p>
        </li>

        <div class="btn">
          <a href="/newUser">メールアドレスを登録し直す</a>
        </div>

        <div v-if="isUiOnlyMode" class="btn">
          <a :href="`/memberRegistration?userId=${emailAddressToCheck}&token=uionlymodetesttoken&trialType=${trialTypeForUiOnlyMode}`">進む (UI Only Mode is set to true)</a>
        </div>

        <!-- <li>
          <p>(4) 上記の方法で解決しなかった場合は、<a href="">こちら</a>よりお問い合わせください。</p>
        </li> -->
      </ul>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CheckEmail',

  props: {
    emailAddressToCheck: {
      type: String,
      required: true
    },

    isUiOnlyMode: {
      type: Boolean,
      required: true
    },

    trialTypeForUiOnlyMode: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
.signup-verify p.title {
  font-size: 24px;
  line-height: 36px;
  font-weight: 600;
  color: black;
  margin-bottom: 18px;
}

.signup-verify p.email-address {
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  color: black;
  margin-bottom: 24px;
}

.signup-verify p.instructions {
  font-size: 14px;
  line-height: 21px;
  color: black;
  margin-bottom: 24px;
}

.tips {
  margin-top: 32px;
  padding: 16px;
  background-color: #efefef;
  border-radius: 4px;
  min-width: 120px;
}

.tips h4 {
  font-size: 16px;
  line-height: 24px;
  font-weight: bold;
  color: black;
  margin-bottom: 20px;
}

.tips ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.tips ul li {
  margin-bottom: 15px;
}

.tips ul li p {
  font-size: 14px;
  line-height: 21px;
}

.tips ul li p span {
  font-weight: bold;
}

.tips ul .btn {
  text-align: center;
  margin: 24px 0;
}

.tips ul .btn a {
  display: inline-block;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-decoration: none;
  background-color: #183582;
  border-radius: 3px;
  font-weight: bold;
  padding: 10px 30px 9px;
  color: #fff;
  font-size: 14px;
  line-height: 21px;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-timing-function: ease-out;
  -o-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
  -webkit-transition-property: color, background, border, opacity;
  -o-transition-property: color, background, border, opacity;
  transition-property: color, background, border, opacity;
  text-align: center;
  cursor: pointer;
}

@media (min-width: 480px) {
  .tips ul .btn a {
    width: auto;
  }
}
</style>
